module.exports = "<div class=\"loading\">\n    <img src=\"./../../assets/giphy.gif\" alt=\"\">\n</div>\n"